export const initMobileMenuOffcanvas = (): void => {
  // Using querySelectorAll because there might be multiple toggle buttons
  // (e.g., standard header + proje-basvuru sidebar)
  const toggleBtns = document.querySelectorAll<HTMLButtonElement>(
    ".mobile-menu-toggle",
  );
  const panel = document.querySelector<HTMLElement>(".mobile-menu-panel");
  const overlay = document.querySelector<HTMLElement>(".mobile-menu-overlay");
  const closeBtn = document.querySelector<HTMLButtonElement>(
    ".mobile-menu-panel__close",
  );
  const body = document.body;

  if (!panel || !overlay) return;

  const openMenu = () => {
    toggleBtns.forEach((btn) => btn.setAttribute("aria-expanded", "true"));
    panel.classList.add("is-open");
    overlay.classList.add("is-open");
    body.style.overflow = "hidden"; // Prevent scrolling of background
  };

  const closeMenu = () => {
    toggleBtns.forEach((btn) => btn.setAttribute("aria-expanded", "false"));
    panel.classList.remove("is-open");
    overlay.classList.remove("is-open");
    body.style.overflow = ""; // Restore scrolling
  };

  // 1. Open Triggers
  toggleBtns.forEach((btn) => btn.addEventListener("click", openMenu));

  // 2. Close Triggers
  closeBtn?.addEventListener("click", closeMenu);
  overlay.addEventListener("click", closeMenu);

  document.addEventListener("keydown", (e) => {
    if (e.key === "Escape" && panel.classList.contains("is-open")) {
      closeMenu();
    }
  });

  // 3. Submenu Toggles (MobileNavWalker logic)
  const submenuToggles = panel.querySelectorAll<HTMLButtonElement>(
    ".mobile-menu-offcanvas__submenu-toggle",
  );

  submenuToggles.forEach((btn) => {
    btn.addEventListener("click", (e) => {
      e.preventDefault();
      const parentItem = btn.closest("li");
      if (parentItem) {
        parentItem.classList.toggle("is-open");
        const isExpanded = parentItem.classList.contains("is-open");
        btn.setAttribute("aria-expanded", String(isExpanded));

        // Rotate chevron
        const icon = btn.querySelector(".icon") as HTMLElement;
        if (icon) {
          icon.style.transform = isExpanded ? "rotate(180deg)" : "rotate(0deg)";
        }
      }
    });
  });

  console.log("[MobileMenu] Initialized (Left-to-Right Offcanvas).");
};
